import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=270b3d9a&scoped=true&"
import script from "./upload-img.vue?vue&type=script&lang=js&"
export * from "./upload-img.vue?vue&type=script&lang=js&"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=270b3d9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b3d9a",
  null
  
)

export default component.exports